import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { detailColumnsDef } from '../../shared/columnDefinitions/effectiveTaxRate';
import AgGrid from '../../shared/agGrid/agGrid.component';
import DetailPopup from '../../shared/detailPopup.component';
import {
  effectiveTaxRateDetailsSelector,
  reportDataSelector,
} from './store/selectors';

class EffectiveTaxRateDetails extends PureComponent {
  static propTypes = {
    rowData: PropTypes.arrayOf(PropTypes.shape({
      section: PropTypes.string,
      sortOrder: PropTypes.number,
      companyCode: PropTypes.string,
      countryTaxType: PropTypes.string,
      countryTaxTypeDescription: PropTypes.string,
      tagDescription: PropTypes.string,
      descr: PropTypes.string,
      amount: PropTypes.number,
      manual: PropTypes.string,
      tagName: PropTypes.string,
      manualEntryId: PropTypes.string,
      businessDescription: PropTypes.string,
      businessCode: PropTypes.string,
      businessUnit: PropTypes.string,
      legalEntity: PropTypes.string,
      countryCode: PropTypes.string,
    })).isRequired,
  };

  render() {
    const {
      rowData,
    } = this.props;


    return (
      <DetailPopup
        id="effectiveTaxRateDetails"
        title="ETR Driver Detail"
        className="ag-theme-bootstrap"
      >
        <AgGrid
          columnDefs={detailColumnsDef}
          rowData={rowData}
        />
      </DetailPopup>
    );
  }
}

export default connect(state => ({
  rowData: effectiveTaxRateDetailsSelector(state),
  reports: reportDataSelector(state),
}))(EffectiveTaxRateDetails);
